import { render } from "./TriagePatientQueueModal.vue?vue&type=template&id=cb73cf32"
import script from "./TriagePatientQueueModal.vue?vue&type=script&lang=js"
export * from "./TriagePatientQueueModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__